import Utils from "../../../../../../../../core/services/utils/utils";
import {normalizeSpreadsheetCellValue} from "../transformers/shared";

export const CODE_GROUP_FIELD_PREFIX = 'codeGroup_';

/**
 * @param {string|number} categoryId
 * @returns {string}
 */
export const codeGroupFieldKey = (categoryId) => `${CODE_GROUP_FIELD_PREFIX}${categoryId}`;

/**
 * @param {string} fieldKey
 * @returns {string|null}
 */
export const categoryIdFromCodeGroupFieldKey = (fieldKey) => {
    if (typeof fieldKey !== 'string' || !fieldKey.startsWith(CODE_GROUP_FIELD_PREFIX)) {
        return null;
    }
    return fieldKey.slice(CODE_GROUP_FIELD_PREFIX.length);
};

/**
 * @param {Array<{name: string}>|null|undefined} mappingFields
 * @returns {Set<string>}
 */
export const buildMappedCodeGroupFieldKeys = (mappingFields) =>
    new Set(
        (mappingFields ?? [])
            .map((field) => field.name)
            .filter((name) => typeof name === 'string' && name.startsWith(CODE_GROUP_FIELD_PREFIX)),
    );

/**
 * Spreadsheet cleanup plus part-code dash folding, for the column-mapper preview.
 * @param {unknown} raw
 * @returns {string}
 */
export const formatPartCodeImportField = (raw) => Utils.normalizePartCode(normalizeSpreadsheetCellValue(raw));

/**
 * @param {unknown} rawCell
 * @param {string} splitter
 * @returns {string[]}
 */
export const parseProductCodesFromCell = (rawCell, splitter) => {
    const normalized = normalizeSpreadsheetCellValue(rawCell);
    if (!normalized) {
        return [];
    }
    const separator = splitter ?? ' ';
    const tokens = normalized
        .split(separator)
        .map((token) => Utils.normalizePartCode(token))
        .filter(Boolean);
    return [...new Set(tokens)];
};

/**
 * @param {string} code
 * @param {string|number|null|undefined} [partnerId]
 * @returns {{ valid: boolean, sanitized: string }}
 */
export const validateProductCodeToken = (code, partnerId) => {
    const sanitized = Utils.normalizePartCode(code);
    if (!sanitized) {
        return {valid: false, sanitized: ''};
    }
    return {valid: true, sanitized};
};

/**
 * @param {string[]} codes
 * @param {string|number|null|undefined} [partnerId]
 * @returns {{ validCodes: string[], invalidCodes: string[] }}
 */
export const partitionProductCodeTokens = (codes, partnerId) => {
    const validCodes = [];
    const invalidCodes = [];
    for (const code of codes ?? []) {
        const {valid, sanitized} = validateProductCodeToken(code, partnerId);
        if (valid) {
            validCodes.push(sanitized);
        } else {
            invalidCodes.push(sanitized || String(code ?? '').trim());
        }
    }
    return {validCodes, invalidCodes};
};

/**
 * @param {*} response
 * @returns {boolean}
 */
export const isDuplicatePartCodeApiResponse = (response) => {
    const message = (response?.message ?? '').toString().toLowerCase();
    return message.includes('already exist') || message.includes('duplicate');
};
